webpackJsonp([3,1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(265);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _router = __webpack_require__(30);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _vue2Filters = __webpack_require__(273);
	
	var _vue2Filters2 = _interopRequireDefault(_vue2Filters);
	
	var _vueRouter = __webpack_require__(167);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _elementUi = __webpack_require__(208);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	__webpack_require__(244);
	
	var _vueDataTables = __webpack_require__(264);
	
	var _vueDataTables2 = _interopRequireDefault(_vueDataTables);
	
	var _en = __webpack_require__(211);
	
	var _en2 = _interopRequireDefault(_en);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_elementUi2.default, { locale: _en2.default });
	
	_vue2.default.use(_vueDataTables2.default);
	_vue2.default.use(_vue2Filters2.default);
	
	_vue2.default.prototype.$API_url = 'https://cococs.org/SlimAPI/public';
	
	
	new _vue2.default({
	  router: _router2.default,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	}).$mount('#app');

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _router = __webpack_require__(30);
	
	var _axios = __webpack_require__(13);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var API_URL = 'http://localhost:8090/';
	
	var LOGIN_URL = API_URL + 'auth';
	var SIGNUP_URL = API_URL + 'users/';
	
	exports.default = {
	  user: {
	    authenticated: false
	  },
	  admin: {
	    authenticated: false
	  },
	  teacher: {
	    authenticated: false,
	    attendance: false,
	    teacher_id: '',
	    token_time: '',
	    teacher_info: {},
	    teacher_name: ''
	  }, login_or_signup: function login_or_signup(action, context, creds, redirect) {
	    var url = '';
	    switch (action) {
	      case 'login':
	        url = LOGIN_URL;
	        break;
	      case 'signup':
	        url = SIGNUP_URL;
	        break;
	      default:
	        url = LOGIN_URL;
	    }
	  },
	  logout: function logout() {
	    localStorage.removeItem('teach_token');
	    this.user.authenticated = false;
	    this.admin.authenticated = false;
	    this.teacher.authenticated = false;
	  },
	  checkAuth: function checkAuth() {
	    var jwt = localStorage.getItem('teach_token');
	    if (jwt) {
	      this.user.authenticated = true;
	    } else {
	      this.user.authenticated = false;
	    }
	  },
	  getAuthHeader: function getAuthHeader() {
	    return {
	      'Authorization': 'Bearer ' + localStorage.getItem('teach_token')
	    };
	  }
	};

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(167);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _attendance = __webpack_require__(268);
	
	var _attendance2 = _interopRequireDefault(_attendance);
	
	var _Teacher_Login = __webpack_require__(266);
	
	var _Teacher_Login2 = _interopRequireDefault(_Teacher_Login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	exports.default = new _vueRouter2.default({
	  mode: 'history',
	  base: __dirname,
	  routes: [{ path: '/teacherlogin', component: _Teacher_Login2.default }, {
	    path: '/attendance',
	    component: _attendance2.default
	  },,]
	});
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _header = __webpack_require__(267);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            msg: 'Hello vue'
	        };
	    },
	
	    components: {
	        HeaderCompontent: _header2.default
	
	    }
	};

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(15);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _axios = __webpack_require__(13);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      teacher: _auth2.default.teacher,
	
	      formLabelWidth: '120px',
	
	      credentials: {
	        user_login: '',
	        user_password: ''
	      },
	      rules: {
	        user_login: [{ required: true, message: 'Please User name', trigger: 'blur' }, { min: 5, message: 'Length should be more than 5 chars', trigger: 'blur' }],
	        user_password: [{ required: true, message: 'Please Password', trigger: 'blur' }, { min: 5, message: 'Length should be more than 5 chars', trigger: 'blur' }] },
	      error: ''
	    };
	  },
	
	  methods: {
	    myEncrypt: function myEncrypt(s, k) {
	      var enc = "";
	      var str = "";
	
	      str = s.toString();
	      for (var i = 0; i < s.length; i++) {
	        var a = s.charCodeAt(i);
	
	        var b = a ^ k;
	        enc = enc + String.fromCharCode(b);
	      }
	      return enc;
	    },
	    submit: function submit() {
	      var _this2 = this;
	
	      var _this = this;
	
	      var credentials = {
	        doit: this.credentials.user_login,
	
	        doitright: this.credentials.user_password
	      };
	
	
	      var key = "123";
	      this.teacher.token_time = new Date().getTime();
	      var inputs = { doit: this.myEncrypt(this.credentials.user_login, key), doitright: this.myEncrypt(this.credentials.user_password, key) };
	
	      _axios2.default.put(this.$API_url + '/lastday1/' + 10, inputs).then(function (response) {
	
	        localStorage.setItem('teach_token', response.data.id_token);
	
	        var list = response.data;
	
	        _this.teacher.teacher_info = list;
	        _this.teacher.teacher_id = list.teacher_id;
	        _this.teacher.teacher_name = list.teacher_fname + ' ' + list.teacher_lname;
	
	        if (list.email2 == 'ReportOnly') {
	          _this2.$message.error('User Prohibited!!');
	        } else {
	          _this.teacher.authenticated = true;
	          _this.$router.push({ path: '/attendance' });
	        }
	      }).catch(function (err) {
	        var statusCode = err.response.data.statusCode,
	            message = err.response.data.message;
	        if (statusCode == 401) _this2.$message.error(message);
	        if (statusCode == 422) _this2.$message.error(message);
	      });
	    }
	  }
	};

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(15);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      user: _auth2.default.user,
	      admin: _auth2.default.admin,
	      teacher: _auth2.default.teacher
	    };
	  },
	
	  methods: {
	    logout: function logout() {
	      _auth2.default.logout();
	      window.location.reload(true);
	      this.$router.push({ path: '/teacher' });
	    }
	  }
	
	};

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(191);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _axios = __webpack_require__(13);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _auth = __webpack_require__(15);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pako = __webpack_require__(250);
	
	var jsPDF = __webpack_require__(44);
	__webpack_require__(248);
	
	exports.default = {
	  data: function data() {
	    var _ref;
	
	    return _ref = {
	      legacySystemHTML: '',
	      teacher_id: _auth2.default.teacher.teacher_id,
	      token_time: _auth2.default.teacher.token_time,
	      teacher_name: _auth2.default.teacher.teacher_name,
	      teacher_info: _auth2.default.teacher.teacher_info,
	      teacher: _auth2.default.teacher,
	
	      isArticleVisible: false,
	      DialogInfo: '',
	      dialogClassCode: false,
	      displaySchoolDate: '',
	      dialogHistory: false,
	      dialogOneHist: false,
	      dialogTeacherForm: false,
	      attendHistory: [],
	      subDate: [],
	      curClassDate: '',
	      nextClassDate: '',
	      absenceDate: '',
	      curClassDateActive: false,
	      curClassId: 0,
	      curClassName: '',
	      curAbsenceCnt: 0,
	      curLateCnt: 0,
	      curLeftCnt: 0,
	      curAttendCnt: 0,
	      newAttend: '',
	      addTeacher: 'Edit Teacher Info',
	      addTeacherTrue: false,
	      selYear_holder: '',
	      multipleSelection: [],
	      teacher_Input: {},
	      teacher_InputArr: [],
	      junkeMail: [{ email: 'suejerryk@yahoo.com' }, { email: 'khuynh_99@yahoo.com' }, { email: 'kaitlindang@gmail.com' }, { email: 'meghandang12@gmail.com' }],
	
	      formLabelWidth: '250px',
	      getrow: {},
	      getDetail: {},
	      checkList: ['Absence', 'Leave'],
	      tmpArr: [],
	      attendActive: false,
	
	      mapMonth: [],
	
	      cols: [],
	      disCols: [],
	      volunteerCatVal: '',
	      volunteerCodeVal: '',
	      selYear: '',
	
	      monthBegin: '',
	      monthEnd: '',
	      monthB: '',
	      monthE: '',
	
	      teacherArr: [],
	      teacherClassesArr: [],
	      filter: '',
	      selectedOptions: [],
	      classOptions: [],
	      classOptions1: [{
	        children: [{}]
	      }],
	
	      formInline: {
	        firstname: 'john',
	        lastname: 'chan'
	      },
	      search: '',
	      loading: false,
	      dialogStudentForm: false,
	      listArr: [],
	      classList: [],
	      teacherList: [],
	      PayStudentClass: [],
	      classArr: [],
	      displayInfo: '',
	      displayTitle: '',
	      displayAbsence: 'ewew',
	      displayAttended: ' att',
	      displayLate: 'late',
	      displayLeft: 'eww',
	      classroom_Input: {}
	    }, (0, _defineProperty3.default)(_ref, 'teacher_Input', {}), (0, _defineProperty3.default)(_ref, 'class_Input', {}), (0, _defineProperty3.default)(_ref, 'thisTeacher', ''), (0, _defineProperty3.default)(_ref, 'teacherAssign', { teacher: '', class: '', existing: 'Dog xxx' }), (0, _defineProperty3.default)(_ref, 'filterCat', []), (0, _defineProperty3.default)(_ref, 'getAttendAbsence', []), (0, _defineProperty3.default)(_ref, 'prevClassAttend', []), (0, _defineProperty3.default)(_ref, 'tmptmp', []), (0, _defineProperty3.default)(_ref, 'attendDatesArr', []), (0, _defineProperty3.default)(_ref, 'classAttendArr', []), (0, _defineProperty3.default)(_ref, 'classAttend', []), (0, _defineProperty3.default)(_ref, 'time1', ''), (0, _defineProperty3.default)(_ref, 'displayCTitle', ''), (0, _defineProperty3.default)(_ref, 'familyVolun', []), _ref;
	  },
	  created: function created() {
	    var today = new Date();
	
	    this.selYear = 2024;
	    this.displayTitle = 'Year: ' + this.selYear + ' - Welcome Teacher ' + this.teacher_name;
	    this.displayCTitle = this.teacher_info.teacher_cname + '老(師/师)好';
	
	    this.loadList();
	  },
	
	
	  filters: {
	    phone: function phone(_phone) {
	      return _phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
	    },
	    formatDate: function formatDate(value) {
	      if (value) {
	        return (0, _moment2.default)(String(value)).format('MM/DD/YYYY hh:mm a');
	      }
	    }
	  },
	
	  methods: {
	    titleCase: function titleCase(str) {
	      return str.toLowerCase().split(' ').map(function (word) {
	        return word.replace(word[0], word[0].toUpperCase());
	      }).join(' ');
	    },
	    checkTimeOut: function checkTimeOut() {
	      var _this2 = this;
	
	      var date1 = new Date().getTime();
	      var delta = (date1 - this.token_time) / 3600 / 1000;
	      if (delta > 9.00) {
	        this.$message({
	          showClose: true,
	          message: 'Login Session Expired!! Please Login Again!',
	          type: 'warning',
	          duration: 5000
	        });
	
	        setTimeout(function () {
	          _this2.logout();
	        }, 5000);
	      }
	    },
	    logout: function logout() {
	
	      _auth2.default.logout();
	      window.location.reload(true);
	      this.$router.push({ path: '/teacher' });
	    },
	    getClasses: function getClasses() {
	
	      this.attendActive = false;
	    },
	    EditStudentCancel: function EditStudentCancel() {
	      this.dialogStudentForm = false;
	    },
	    goEditStudentCName: function goEditStudentCName(row) {
	      this.getrow = row;
	      this.dialogStudentForm = true;
	    },
	    dateBegin: function dateBegin(val) {
	      this.monthBegin = val;
	      this.monthE = '';
	    },
	    dateEnd: function dateEnd(val) {
	      var tmpdate;
	      var tbegin = this.monthBegin.split("-");
	      var tend = val.split("-");
	      this.disCols = [];
	
	      if (this.monthBegin != '') {
	        for (var i = this.cols.length - 1; i >= 0; i--) {
	          tmpdate = this.cols[i].prop.split("-");
	          if (tmpdate[0] >= tbegin[0] && tmpdate[1] >= tbegin[1] && (tend[0] > tmpdate[0] || tend[0] >= tmpdate[0] && tend[1] >= tmpdate[1])) {
	            this.disCols.push(this.cols[i]);
	          }
	        }
	      }
	    },
	    EditStudent: function EditStudent() {
	      var _this = this;
	      this.dialogStudentForm = false;
	      var tzoffset = new Date().getTimezoneOffset() * 60000;
	      var localISOTime = new Date(Date.now() - tzoffset).toISOString().slice(0, -1).substring(0, 19).replace('T', ' ');
	
	      var inputs = { chinese_name: this.getrow.chinese_name, modified: localISOTime };
	      if (this.getrow.chinese_name != '') {
	        _axios2.default.put(this.$API_url + '/student_cname/' + this.getrow.student_id, inputs, { headers: _auth2.default.getAuthHeader() }).then(function (response) {
	          var statusCode = response.data.statusCode,
	              message = response.data.message;
	          if (statusCode == 200) _this.$message.success(message);
	        }).catch(function (error) {
	          var statusCode = err.response.data.statusCode,
	              message = err.response.data.message;
	          _this.$message.error(message);
	        });
	      } else {
	        _this.$message.error('Empty Entry! Nothing Change!');
	      }
	    },
	    subAttendance: function subAttendance() {
	      var _this3 = this;
	
	      var _this = this;
	
	      var tzoffset = new Date().getTimezoneOffset() * 60000;
	      var localISOTime = new Date(Date.now() - tzoffset).toISOString().slice(0, -1).substring(0, 19).replace('T', ' ');
	
	      var tdate = this.curClassDate;
	
	      var newInput = [];
	      var updateInput = [];
	
	
	      if (this.getAttendAbsence.length > 0) {
	        for (var i = 0; i < this.classAttend.length; i++) {
	          if (this.classAttend[i].absence != this.prevClassAttend[i].absence) {
	            if (this.classAttend[i].prev) {
	              updateInput.push({ id: this.classAttend[i].id, absence: this.classAttend[i].absence, created: localISOTime });
	            } else {
	              newInput.push({ class_id: this.curClassId, student_id: this.classAttend[i].student_id,
	                date: tdate, absence: this.classAttend[i].absence, created: localISOTime });
	            }
	          }
	        }
	      } else {
	        newInput.push({ class_id: this.curClassId, student_id: 0, date: tdate, absence: 0, created: localISOTime });
	
	        for (var i = 0; i < this.classAttend.length; i++) {
	
	          if (this.classAttend[i].absence != 0) {
	            newInput.push({ class_id: this.curClassId, student_id: this.classAttend[i].student_id,
	              date: tdate, absence: this.classAttend[i].absence, created: localISOTime });
	          }
	        }
	      }
	
	      if (newInput.length > 0) {
	        _axios2.default.put(this.$API_url + '/addAttendance/' + 10, newInput, { headers: _auth2.default.getAuthHeader() }).then(function (response) {}).catch(function (error) {
	          console.log(error);
	        });
	      }
	
	      if (updateInput.length > 0) {
	
	        _axios2.default.put(this.$API_url + '/udateAttendance/' + 10, updateInput, { headers: _auth2.default.getAuthHeader() }).then(function (response) {}).catch(function (error) {
	          console.log(error);
	        });
	      }
	
	      setTimeout(function () {
	        _this3.attendActive = false;
	      }, 500);
	    },
	    atos: function atos(arr) {
	      for (var i = 0, l = arr.length, s = '', c; c = arr[i++];) {
	        s += String.fromCharCode(c > 0xdf && c < 0xf0 && i < l - 1 ? (c & 0xf) << 12 | (arr[i++] & 0x3f) << 6 | arr[i++] & 0x3f : c > 0x7f && i < l ? (c & 0x1f) << 6 | arr[i++] & 0x3f : c);
	      }return s;
	    },
	    object_merge: function object_merge() {
	      for (var i = 1; i < arguments.length; i++) {
	        for (var a in arguments[i]) {
	          arguments[0][a] = arguments[i][a];
	        }
	      }return arguments[0];
	    },
	    doneHistory: function doneHistory() {
	      this.dialogHistory = false;
	    },
	    formatCell: function formatCell(row, col, cellVal) {
	      if (cellVal != undefined) {
	        switch (cellVal) {
	          case 1:
	            return 'ABSENT';
	            break;
	          case 2:
	            return 'LATE';
	            break;
	          case 3:
	            return 'LEFT';
	            break;
	          case 0:
	            return 'P';
	            break;
	        }
	      } else {
	        if (this.subDate[col.property]) return 'P';else return 'X';
	      }
	
	      return cellVal;
	    },
	    handleSelect: function handleSelect(val) {
	      console.log('val S', val, 'absence', val.absence);
	
	      if (val.absence != 1) this.$message({
	        message: 'Not Absence!!',
	        type: 'info' });
	    },
	    SetupEmail: function SetupEmail() {
	
	      this.dialogTeacherForm = true;
	    },
	    AttendanceEmail: function AttendanceEmail() {
	      var _this = this;
	
	      if (this.multipleSelection.length > 0) {
	
	        _axios2.default.put(this.$API_url + '/emailAttendance?name=' + this.teacher_name + '&email=' + this.teacher_info.email + '&date=' + this.absenceDate + '&cname=' + this.teacher_info.teacher_cname + '&class=' + this.curClassName, this.multipleSelection, { headers: _auth2.default.getAuthHeader() }).then(function (response) {
	          console.log(_this.legacySystemHTML);
	          _this.$message({
	            showClose: true,
	            message: response.data,
	            type: 'info' });
	        }).catch(function (err) {
	          if (err.response !== undefined) {
	            var statusCode = err.response.data.statusCode,
	                message = err.response.data.message;
	
	            _this.$message.error(message);
	          } else _this.$message.error('Something Went Wrong with Sending Emails!!!');
	        });
	      } else {
	        this.$message({
	          message: 'No student selected!! No emails send',
	          type: 'info' });
	      }
	    },
	    PreviewEmail: function PreviewEmail() {},
	    EditTeacherCancel: function EditTeacherCancel() {
	      this.dialogTeacherForm = false;
	    },
	    EditTeacher: function EditTeacher() {
	      this.dialogTeacherForm = false;
	      console.log('edit teacher_Input student', this.teacher_Input);
	    },
	    handleSelectionChange: function handleSelectionChange(val) {
	      var _this4 = this;
	
	      this.multipleSelection = [];
	      val.forEach(function (row) {
	        if (row.absence !== 1) _this4.$refs.multipleTable.toggleRowSelection(row);
	      });
	      this.multipleSelection = val;
	    },
	    DoneOneHist: function DoneOneHist() {
	      this.dialogOneHist = false;
	    },
	    getOneHist: function getOneHist(row, column, cell, event) {
	      var trow;
	      if (this.subDate[column.property]) {
	        trow = { date: column.property };
	        this.dialogOneHist = true;
	        this.getAttendance(trow);
	        this.absenceDate = trow.date;
	      } else {
	
	        this.$message({
	          message: 'Nothing to show!!',
	          type: 'info'
	        });
	      }
	    },
	    getHistory: function getHistory(row) {
	
	      this.checkTimeOut();
	
	      var _this = this;
	
	      this.$off('triggerAttend');
	      this.curClassId = row.class_id;
	      this.curClassName = row.fullclass;
	
	      this.attendHistory = [];
	      this.subDate = [];
	
	      _axios2.default.all([_axios2.default.get(this.$API_url + '/payclassesClasscode?class_id=' + row.class_id + '&year=' + _this.selYear, {
	        params: {}, headers: _auth2.default.getAuthHeader()
	      }), _axios2.default.get(this.$API_url + '/getAbsenceByClassId/' + row.class_id, {
	        params: {}, headers: _auth2.default.getAuthHeader()
	      })]).then(_axios2.default.spread(function (PayClassCode, AttendAbsence) {
	        _this.classAttendArr = JSON.parse(_this.atos(pako.ungzip(atob(PayClassCode.data))));
	
	        _this.getAttendAbsence = AttendAbsence.data;
	
	        _this.$emit('triggerAttend');
	      })).catch(function (error) {
	        console.log(error);
	        _this.$message({
	          showClose: true,
	          message: 'Login Session Expired!! Please Login Again!',
	          type: 'warning',
	          duration: 5000
	        });
	      });
	
	      this.$on('triggerAttend', function () {
	
	        var histList = [],
	            histDate = [];var i, j, tmpdate, tmpvar;var tmpobj = {};var mobj;var result,
	            atdate = {};
	
	        if (this.getAttendAbsence.length > 0) {
	          for (i = 0; i < this.getAttendAbsence.length; i++) {
	            if (this.getAttendAbsence[i].student_id == 0) {
	              tmpdate = this.getAttendAbsence[i].date.split("T");
	
	              this.subDate[tmpdate[0]] = true;
	            }
	          }
	
	
	          for (i = 0; i < this.classAttendArr.length; i++) {
	
	            tmpvar = this.classAttendArr[i].student_id;
	
	            var result1 = this.getAttendAbsence.filter(function (el) {
	              return el.student_id === tmpvar;
	            });
	
	            if (result1.length > 0) {
	              mobj = {};tmpobj = {};
	              for (j = 0; j < result1.length; j++) {
	                tmpdate = result1[j].date.split("T");tmpvar = tmpdate[0];
	                tmpobj[tmpvar] = result1[j].absence;
	              }
	
	
	              mobj = this.object_merge({}, { student_name: this.titleCase(this.classAttendArr[i].student_name) }, tmpobj);
	              histList.push(mobj);
	            } else {
	              histList.push({ student_name: this.titleCase(this.classAttendArr[i].student_name) });
	            }
	          }
	        }
	
	        this.DialogInfo = 'Attendance History for Class : ' + this.curClassName + '  ::::: P = Present , X = Attendance not taken or not yet taken';
	        this.attendHistory = histList;
	        this.dialogHistory = true;
	      });
	    },
	    DoneDialogClassCode: function DoneDialogClassCode() {
	      this.dialogClassCode = false;
	    },
	    detailClass: function detailClass(row) {
	
	      this.getDetail = row;
	
	      var _this = this;
	      var tdate;
	
	      this.dialogClassCode = true;
	
	      this.curClassId = row.class_id;
	      this.curClassName = row.fullclass;
	      tdate = this.curClassDate;
	
	      this.$off('triggerAttend');
	
	
	      this.checkTimeOut();
	
	      _axios2.default.all([_axios2.default.get(this.$API_url + '/payclassesClasscode?class_id=' + this.curClassId + '&year=' + _this.selYear, {
	        params: {}, headers: _auth2.default.getAuthHeader()
	      }), _axios2.default.get(this.$API_url + '/getAbsenceByClassIdDate?class_id=' + this.curClassId + '&date=' + tdate, {
	        params: {}, headers: _auth2.default.getAuthHeader()
	      })]).then(_axios2.default.spread(function (PayClassCode, AttendAbsence) {
	        _this.classAttendArr = JSON.parse(_this.atos(pako.ungzip(atob(PayClassCode.data))));
	
	        _this.getAttendAbsence = AttendAbsence.data;
	
	        _this.$emit('triggerAttend');
	      })).catch(function (error) {
	        console.log(error);
	      });
	
	      this.$on('triggerAttend', function () {});
	    },
	    handleDownload: function handleDownload(pdf) {
	      var _this5 = this;
	
	      var list = [];
	      var i;
	
	
	      list = this.classAttendArr;
	
	      var selYear = this.selYear;
	      var ymargin = 50;
	      var noteText = '';
	      var fullclass = this.getDetail.fullclass;
	
	      var title = this.getDetail.fullclass + ' : ' + this.getDetail.title;
	      var chinese_title = this.getDetail.chinese_title;
	      var cteacher = this.teacher_info.teacher_cname;
	
	      var teacher = this.teacher_name,
	          classroom = this.getDetail.classroom,
	          total = list.length;
	
	
	      if (pdf === 'pdf' || pdf == 'post' || pdf === 'pdfFirst') {
	
	        if (pdf === 'post') var doc = new jsPDF('p');else var doc = new jsPDF('l');
	
	        var teachDat = [{ header: 'Class  : ' + title }, { header: 'Teacher  : ' + teacher }, { header: 'Classroom : ' + classroom + ' ,  Number of Students : ' + total }];
	
	        if (pdf == 'post') {
	          var getColumns = [{ title: "Students", dataKey: "student_name" }, { title: "Parents", dataKey: "parent_name" }, { title: "Email", dataKey: "email" }, { title: "Phone", dataKey: "phone" }];
	        } else {
	
	          var getColumns = [{ title: "Students", dataKey: "student_name" }, { title: "Parents", dataKey: "parent_name" }, { title: "Phone", dataKey: "phone" }, { title: "EC Person", dataKey: "ecp_name" }, { title: "EC Phone", dataKey: "ecp_phone" }, { title: "Medical Condition", dataKey: "medical_cond" }, { title: "Allergy", dataKey: "allergy" }, { title: "Dr. Name", dataKey: "doctor_name" }, { title: "Dr. Phone", dataKey: "doctor_phone" }, { title: "Medical Insurance", dataKey: "ins_company" }, { title: "Insurance #", dataKey: "ins_policy" }];
	        }
	
	        var headColumns = [{ title: "Header", dataKey: "header" }];
	
	        var totalPagesExp = "{total_pages_count_string}";
	
	        var pageContent = function pageContent(data) {
	          var str = "Page " + data.pageCount;
	
	          if (typeof doc.putTotalPages === 'function') {
	            str = str + " of " + totalPagesExp + '  --- Year: ' + selYear + ', ' + title;
	          }
	          doc.setFontSize(10);
	          doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
	        };
	
	        doc.autoTable(headColumns, teachDat, {
	          showHeader: 'never',
	
	          styles: { cellPadding: 1, fontSize: 12 },
	
	          columnStyles: {
	            header: { font: 'Times', fontStyle: 'bold' }
	          }
	        });
	
	        doc.autoTable(getColumns, list, {
	          addPageContent: pageContent,
	
	          theme: 'grid',
	          margin: { horizontal: 10 },
	          startY: ymargin,
	
	          styles: { fontSize: 10, overflow: 'linebreak', columnWidth: 'auto', minCellWidth: 'wrap' },
	          columnStyles: { medical_cond: { columnWidth: 20 },
	            ins_company: { columnWidth: 20 },
	            allergy: { columnWidth: 25 },
	            doctor_name: { columnWidth: 25 },
	            ins_policy: { columnWidth: 20 },
	            phone: { columnWidth: 18 },
	            ecp_phone: { columnWidth: 18 },
	            doctor_phone: { columnWidth: 18 }
	          }
	
	        });
	
	        if (typeof doc.putTotalPages === 'function') {
	          doc.putTotalPages(totalPagesExp);
	        }
	
	        doc.save(fullclass + '-Year' + selYear);
	      } else {
	
	        var tyear = ["Year", selYear, '', '', '', '', '', ''];
	        var tclass = ["Class (課程)", title, chinese_title, '', '', '', '', ''];
	        var tteacher = ["Teacher (授課老師)", teacher + '(' + cteacher + ')', '', '', '', '', '', '', ''];
	
	        var tclassroom = ["Classroom (教室)", classroom, '', '', '', '', '', ''];
	        var tempty = ["", '', '', '', '', '', '', ''];
	        var ttotal = ["Total", total, '', '', '', '', '', ''];
	
	        if (pdf == 'cp') {
	
	          __webpack_require__.e/* nsure */(0, function () {
	            var _require = __webpack_require__(31),
	                my_export_json_to_excel = _require.my_export_json_to_excel;
	
	            var tHeader = ["Students", '中文名字', "Parents", 'Email', 'Phone'];
	            var filterVal = ['student_name', 'chinese_name', 'parent_name', 'email', 'phone'];
	
	            var data = _this5.formatJson(filterVal, list);
	
	            data.unshift(tHeader);data.unshift(tempty);data.unshift(tclassroom);
	
	            data.unshift(tteacher);
	            data.unshift(tclass);data.unshift(tyear);
	
	            data.push(tempty);data.push(ttotal);
	
	            my_export_json_to_excel(data, fullclass + '-Year' + selYear, true);
	          });
	        } else {
	
	          __webpack_require__.e/* nsure */(0/* duplicate */, function () {
	            var _require2 = __webpack_require__(31),
	                my_export_json_to_excel = _require2.my_export_json_to_excel;
	
	            var tHeader = ["Students", '中文名字', "Parents", 'Email', 'Phone', 'EC Person', 'EC Phone', 'Medical Condition', 'Allergy', "Dr. Name", "Dr. Phone", "Medical Insurance", "Insurance #"];
	            var filterVal = ['student_name', 'chinese_name', 'parent_name', 'email', 'phone', 'ecp_name', 'ecp_phone', 'medical_cond', 'allergy', 'doctor_name', 'doctor_phone', 'ins_company', 'ins_policy'];
	
	            var data = _this5.formatJson(filterVal, list);
	
	            data.unshift(tHeader);data.unshift(tempty);data.unshift(tclassroom);
	
	            data.unshift(tteacher);
	            data.unshift(tclass);data.unshift(tyear);
	
	            data.push(tempty);data.push(ttotal);
	
	            my_export_json_to_excel(data, fullclass + '-Year' + selYear);
	          });
	        }
	      }
	    },
	    formatJson: function formatJson(filterVal, jsonData) {
	      return jsonData.map(function (v) {
	        return filterVal.map(function (j) {
	          return v[j];
	        });
	      });
	    },
	    getAttendance: function getAttendance(row) {
	      var _this = this;
	      var tdate;
	
	      if (!this.dialogOneHist) {
	        this.curClassId = row.class_id;
	        this.curClassName = row.fullclass;
	        tdate = this.curClassDate;
	      } else {
	        tdate = row.date;
	      }
	
	      this.$off('triggerAttend');
	
	
	      this.checkTimeOut();
	
	      _axios2.default.all([_axios2.default.get(this.$API_url + '/payclassesClasscode?class_id=' + this.curClassId + '&year=' + _this.selYear, {
	        params: {}, headers: _auth2.default.getAuthHeader()
	      }), _axios2.default.get(this.$API_url + '/getAbsenceByClassIdDate?class_id=' + this.curClassId + '&date=' + tdate, {
	        params: {}, headers: _auth2.default.getAuthHeader()
	      })]).then(_axios2.default.spread(function (PayClassCode, AttendAbsence) {
	        _this.classAttendArr = JSON.parse(_this.atos(pako.ungzip(atob(PayClassCode.data))));
	
	        _this.getAttendAbsence = AttendAbsence.data;
	
	        _this.$emit('triggerAttend');
	      })).catch(function (error) {
	        console.log(error);
	      });
	
	      this.$on('triggerAttend', function () {
	        this.processjunk();
	      });
	    },
	    processjunk: function processjunk() {
	      var _this6 = this;
	
	      if (!this.dialogOneHist) this.attendActive = true;
	
	      var _this = this;
	      var list = [];
	      this.classAttend = [];
	      this.prevClassAttend = [];
	      this.curAbsenceCnt = 0;
	      this.curLateCnt = 0;
	      this.curLeftCnt = 0;
	      this.curAttendCnt = 0;
	      var histList = [];
	      var cname = '';
	      var tmp = '';
	      var notcname = false;
	
	      if (_this.getAttendAbsence.length > 0) {
	        this.newAttend = ' Updated ';
	
	        for (var i = 0; i < this.classAttendArr.length; i++) {
	          notcname = false;
	          cname = this.classAttendArr[i].chinese_name;
	          tmp = this.classAttendArr[i].chinese_name.replace(/ /g, '');
	
	          if (!tmp.toString().match(/[\u3400-\u9FBF]/) && tmp != '') notcname = true;
	
	          var result = this.getAttendAbsence.find(function (x) {
	            return x.student_id === _this6.classAttendArr[i].student_id;
	          });
	
	          if (result === undefined) {
	            this.classAttend.push({ student_name: this.titleCase(this.classAttendArr[i].student_name), absence: 0,
	              chinese_name: cname, notcname: notcname, email: this.classAttendArr[i].email, student_id: this.classAttendArr[i].student_id, prev: false, id: 0 });
	            this.prevClassAttend.push({ student_name: this.titleCase(this.classAttendArr[i].student_name), absence: 0,
	              student_id: this.classAttendArr[i].student_id, prev: false, id: 0 });
	            this.curAttendCnt++;
	          } else {
	
	            this.classAttend.push({ student_name: this.titleCase(this.classAttendArr[i].student_name), absence: result.absence,
	              chinese_name: cname, notcname: notcname, email: this.classAttendArr[i].email, student_id: this.classAttendArr[i].student_id, prev: true, id: result.id });
	            this.prevClassAttend.push({ student_name: this.titleCase(this.classAttendArr[i].student_name), absence: result.absence,
	              student_id: this.classAttendArr[i].student_id, prev: true, id: result.id });
	
	            switch (result.absence) {
	              case 1:
	                this.curAbsenceCnt++;
	                break;
	              case 2:
	                this.curLateCnt++;
	                break;
	              case 3:
	                this.curLeftCnt++;
	                break;
	              case 0:
	                this.curAttendCnt++;
	                break;
	            }
	          }
	        }
	      } else {
	        this.newAttend = ' New ';
	
	        for (var i = 0; i < this.classAttendArr.length; i++) {
	          notcname = false;
	          cname = this.classAttendArr[i].chinese_name;
	          tmp = this.classAttendArr[i].chinese_name.replace(/ /g, '');
	          if (!tmp.toString().match(/[\u3400-\u9FBF]/) && tmp != '') notcname = true;
	
	          this.classAttend.push({ student_name: this.titleCase(this.classAttendArr[i].student_name), absence: 0,
	            chinese_name: cname, notcname: notcname, email: this.classAttendArr[i].email, student_id: this.classAttendArr[i].student_id, prev: false, id: 0 });
	          this.prevClassAttend.push({ student_name: this.titleCase(this.classAttendArr[i].student_name), absence: 0,
	            student_id: this.classAttendArr[i].student_id, prev: false, id: 0 });
	          this.curAttendCnt++;
	        }
	      }
	
	
	      this.displayAbsence = 'Absent  (' + this.curAbsenceCnt + ')';
	      this.displayAttended = 'Present (' + this.curAttendCnt + ')';
	      this.displayLate = 'Late   (' + this.curLateCnt + ')';
	      this.displayLeft = 'Leave Early (' + this.curLeftCnt + ')';
	
	      this.displayInfo = '   Class : ' + this.curClassName + ' , Number of Students : ' + this.classAttendArr.length;
	    },
	    changeStatus: function changeStatus(index, row, status) {
	
	      if (this.classAttend[index].absence != status) {
	
	        switch (status) {
	          case 1:
	            this.curAbsenceCnt++;
	            break;
	          case 2:
	            this.curLateCnt++;
	            break;
	          case 3:
	            this.curLeftCnt++;
	            break;
	          case 0:
	            this.curAttendCnt++;
	            break;
	        }
	
	        switch (this.classAttend[index].absence) {
	          case 1:
	            this.curAbsenceCnt--;
	            break;
	          case 2:
	            this.curLateCnt--;
	            break;
	          case 3:
	            this.curLeftCnt--;
	            break;
	          case 0:
	            this.curAttendCnt--;
	            break;
	        }
	        this.classAttend[index].absence = status;
	      }
	
	      this.displayAbsence = 'Absent  (' + this.curAbsenceCnt + ')';
	      this.displayAttended = 'Present (' + this.curAttendCnt + ')';
	      this.displayLate = 'Late   (' + this.curLateCnt + ')';
	      this.displayLeft = 'Leave Early (' + this.curLeftCnt + ')';
	    },
	    processCategory: function processCategory() {
	      var _this = this;
	      _this.teacherArr = [];
	      _this.classArr = [];
	
	      var i, j;
	
	      j = 1;
	      var cat = {};
	      var code = [];
	      var opt = [];
	      var mapMonth = [];
	      mapMonth['01'] = 'JAN';
	      mapMonth['02'] = 'FEB';mapMonth['03'] = 'MAR';mapMonth['04'] = 'APR';mapMonth['05'] = 'MAY';mapMonth['06'] = 'JUN';
	      mapMonth['07'] = 'JUL';mapMonth['08'] = 'AUG';mapMonth['09'] = 'SEP';mapMonth['10'] = 'OCT';mapMonth['11'] = 'NOV';mapMonth['12'] = 'DEC';
	
	      this.$off('triggerLoad');
	      var tmpdate1, tmpdate, month, day;
	      var d = new Date();
	
	      this.cols = [];
	
	      var tzoffset = new Date().getTimezoneOffset() * 60000;
	      var localISOTime = new Date(Date.now() - tzoffset).toISOString().slice(0, -1).substring(0, 19).replace('T', ' ');
	      var today = localISOTime.split(' ');var prevWeek, nextWeek;
	
	      this.curClassDate = '';
	      this.curClassDateActive = false;
	      var year;
	      for (i = 0; i < this.attendDatesArr.length; i++) {
	        tmpdate = this.attendDatesArr[i].date.split("T");
	        tmpdate1 = tmpdate[0].split("-");
	        year = tmpdate1[0];
	        month = tmpdate1[1];
	        day = tmpdate1[2];
	
	
	        if (tmpdate[0] == today[0]) {
	          this.curClassDate = tmpdate[0];
	          this.curClassDateActive = true;
	        }
	
	        if (tmpdate[0] <= today[0]) {
	          this.cols.push({ prop: tmpdate[0], label: '## ' + year + ' #' + mapMonth[month] + '-' + day, width: 100 });
	        } else if (i < this.attendDatesArr.length - 1) {
	          this.nextClassDate = tmpdate[0];
	
	          break;
	        }
	      }
	      if (this.curClassDateActive) this.displaySchoolDate = ' Attendance Sheet for Class Date : ' + this.curClassDate;else this.displaySchoolDate = ' Today is not Class Date : ' + today[0] + '    :::  Next Class Date is  ' + this.nextClassDate;
	
	      this.disCols = [];
	
	      var tbegin = 0;
	      if (this.cols.length > 6) {
	        tbegin = this.cols.length - 7;
	      }
	      for (i = this.cols.length - 1; i >= tbegin; i--) {
	        this.disCols.push(this.cols[i]);
	      }
	    },
	    loadList: function loadList() {
	      var _this = this;
	      var i, j;
	
	
	      if (this.teacher.authenticated) {
	
	        _axios2.default.all([_axios2.default.get(this.$API_url + '/getTeacherClasses?teacher_id=' + _this.teacher_id + '&year=' + _this.selYear, {
	          params: {}, headers: _auth2.default.getAuthHeader()
	        }), _axios2.default.get(this.$API_url + '/attend_dates/' + _this.selYear, {
	          params: {}, headers: _auth2.default.getAuthHeader()
	        }), _axios2.default.get(this.$API_url + '/classcode/' + _this.selYear, {
	          params: {}, headers: _auth2.default.getAuthHeader()
	        })]).then(_axios2.default.spread(function (TeacherClass, attendDates, ClassCode) {
	          _this.teacherClassesArr = JSON.parse(_this.atos(pako.ungzip(atob(TeacherClass.data))));
	
	          _this.attendDatesArr = attendDates.data;
	
	          _this.classList = ClassCode.data;
	
	          _this.$emit('triggerLoad');
	        })).catch(function (error) {
	          _this.$message.error('Login Expired!! Please logout and login again');
	        });
	
	        this.$on('triggerLoad', function () {
	          this.processCategory();
	        });
	      }
	    },
	    tableRowClassName: function tableRowClassName(row, index) {
	
	      if (row.teacher_id % 4 === 0) {
	        return 'info-row';
	      } else if (row.teacher_id % 3 === 0) {
	        return 'positive-row';
	      } else {}
	      return '';
	    }
	  }, beforeRouteEnter: function beforeRouteEnter(to, from, next) {
	
	    next(function (vm) {
	
	      if (!vm.teacher.authenticated) vm.$router.push({ path: '/' });
	    });
	  }
	};

/***/ }),

/***/ 244:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 246:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 45,
		"./af.js": 45,
		"./ar": 52,
		"./ar-dz": 46,
		"./ar-dz.js": 46,
		"./ar-kw": 47,
		"./ar-kw.js": 47,
		"./ar-ly": 48,
		"./ar-ly.js": 48,
		"./ar-ma": 49,
		"./ar-ma.js": 49,
		"./ar-sa": 50,
		"./ar-sa.js": 50,
		"./ar-tn": 51,
		"./ar-tn.js": 51,
		"./ar.js": 52,
		"./az": 53,
		"./az.js": 53,
		"./be": 54,
		"./be.js": 54,
		"./bg": 55,
		"./bg.js": 55,
		"./bn": 56,
		"./bn.js": 56,
		"./bo": 57,
		"./bo.js": 57,
		"./br": 58,
		"./br.js": 58,
		"./bs": 59,
		"./bs.js": 59,
		"./ca": 60,
		"./ca.js": 60,
		"./cs": 61,
		"./cs.js": 61,
		"./cv": 62,
		"./cv.js": 62,
		"./cy": 63,
		"./cy.js": 63,
		"./da": 64,
		"./da.js": 64,
		"./de": 67,
		"./de-at": 65,
		"./de-at.js": 65,
		"./de-ch": 66,
		"./de-ch.js": 66,
		"./de.js": 67,
		"./dv": 68,
		"./dv.js": 68,
		"./el": 69,
		"./el.js": 69,
		"./en-au": 70,
		"./en-au.js": 70,
		"./en-ca": 71,
		"./en-ca.js": 71,
		"./en-gb": 72,
		"./en-gb.js": 72,
		"./en-ie": 73,
		"./en-ie.js": 73,
		"./en-nz": 74,
		"./en-nz.js": 74,
		"./eo": 75,
		"./eo.js": 75,
		"./es": 77,
		"./es-do": 76,
		"./es-do.js": 76,
		"./es.js": 77,
		"./et": 78,
		"./et.js": 78,
		"./eu": 79,
		"./eu.js": 79,
		"./fa": 80,
		"./fa.js": 80,
		"./fi": 81,
		"./fi.js": 81,
		"./fo": 82,
		"./fo.js": 82,
		"./fr": 85,
		"./fr-ca": 83,
		"./fr-ca.js": 83,
		"./fr-ch": 84,
		"./fr-ch.js": 84,
		"./fr.js": 85,
		"./fy": 86,
		"./fy.js": 86,
		"./gd": 87,
		"./gd.js": 87,
		"./gl": 88,
		"./gl.js": 88,
		"./gom-latn": 89,
		"./gom-latn.js": 89,
		"./he": 90,
		"./he.js": 90,
		"./hi": 91,
		"./hi.js": 91,
		"./hr": 92,
		"./hr.js": 92,
		"./hu": 93,
		"./hu.js": 93,
		"./hy-am": 94,
		"./hy-am.js": 94,
		"./id": 95,
		"./id.js": 95,
		"./is": 96,
		"./is.js": 96,
		"./it": 97,
		"./it.js": 97,
		"./ja": 98,
		"./ja.js": 98,
		"./jv": 99,
		"./jv.js": 99,
		"./ka": 100,
		"./ka.js": 100,
		"./kk": 101,
		"./kk.js": 101,
		"./km": 102,
		"./km.js": 102,
		"./kn": 103,
		"./kn.js": 103,
		"./ko": 104,
		"./ko.js": 104,
		"./ky": 105,
		"./ky.js": 105,
		"./lb": 106,
		"./lb.js": 106,
		"./lo": 107,
		"./lo.js": 107,
		"./lt": 108,
		"./lt.js": 108,
		"./lv": 109,
		"./lv.js": 109,
		"./me": 110,
		"./me.js": 110,
		"./mi": 111,
		"./mi.js": 111,
		"./mk": 112,
		"./mk.js": 112,
		"./ml": 113,
		"./ml.js": 113,
		"./mr": 114,
		"./mr.js": 114,
		"./ms": 116,
		"./ms-my": 115,
		"./ms-my.js": 115,
		"./ms.js": 116,
		"./my": 117,
		"./my.js": 117,
		"./nb": 118,
		"./nb.js": 118,
		"./ne": 119,
		"./ne.js": 119,
		"./nl": 121,
		"./nl-be": 120,
		"./nl-be.js": 120,
		"./nl.js": 121,
		"./nn": 122,
		"./nn.js": 122,
		"./pa-in": 123,
		"./pa-in.js": 123,
		"./pl": 124,
		"./pl.js": 124,
		"./pt": 126,
		"./pt-br": 125,
		"./pt-br.js": 125,
		"./pt.js": 126,
		"./ro": 127,
		"./ro.js": 127,
		"./ru": 128,
		"./ru.js": 128,
		"./sd": 129,
		"./sd.js": 129,
		"./se": 130,
		"./se.js": 130,
		"./si": 131,
		"./si.js": 131,
		"./sk": 132,
		"./sk.js": 132,
		"./sl": 133,
		"./sl.js": 133,
		"./sq": 134,
		"./sq.js": 134,
		"./sr": 136,
		"./sr-cyrl": 135,
		"./sr-cyrl.js": 135,
		"./sr.js": 136,
		"./ss": 137,
		"./ss.js": 137,
		"./sv": 138,
		"./sv.js": 138,
		"./sw": 139,
		"./sw.js": 139,
		"./ta": 140,
		"./ta.js": 140,
		"./te": 141,
		"./te.js": 141,
		"./tet": 142,
		"./tet.js": 142,
		"./th": 143,
		"./th.js": 143,
		"./tl-ph": 144,
		"./tl-ph.js": 144,
		"./tlh": 145,
		"./tlh.js": 145,
		"./tr": 146,
		"./tr.js": 146,
		"./tzl": 147,
		"./tzl.js": 147,
		"./tzm": 149,
		"./tzm-latn": 148,
		"./tzm-latn.js": 148,
		"./tzm.js": 149,
		"./uk": 150,
		"./uk.js": 150,
		"./ur": 151,
		"./ur.js": 151,
		"./uz": 153,
		"./uz-latn": 152,
		"./uz-latn.js": 152,
		"./uz.js": 153,
		"./vi": 154,
		"./vi.js": 154,
		"./x-pseudo": 155,
		"./x-pseudo.js": 155,
		"./yo": 156,
		"./yo.js": 156,
		"./zh-cn": 157,
		"./zh-cn.js": 157,
		"./zh-hk": 158,
		"./zh-hk.js": 158,
		"./zh-tw": 159,
		"./zh-tw.js": 159
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 249;


/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(12)(
	  /* script */
	  __webpack_require__(186),
	  /* template */
	  __webpack_require__(271),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(246)
	
	var Component = __webpack_require__(12)(
	  /* script */
	  __webpack_require__(187),
	  /* template */
	  __webpack_require__(270),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(247)
	
	var Component = __webpack_require__(12)(
	  /* script */
	  __webpack_require__(188),
	  /* template */
	  __webpack_require__(272),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(245)
	
	var Component = __webpack_require__(12)(
	  /* script */
	  __webpack_require__(189),
	  /* template */
	  __webpack_require__(269),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 269:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "app-container"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.dialogHistory),
	      expression: "!dialogHistory"
	    }]
	  }, [_c('el-row', [_c('el-col', {
	    staticClass: "bigbolds",
	    attrs: {
	      "span": 20
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple-light",
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v(_vm._s(_vm.displayTitle))])]), _vm._v(" "), _c('el-col', {
	    staticClass: "bigbolds",
	    attrs: {
	      "span": 20
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple-light",
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v(_vm._s(_vm.displayCTitle))])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 3
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple"
	  })]), _vm._v(" "), _c('el-col', {
	    staticClass: "bolds",
	    attrs: {
	      "span": 14
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple-light",
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v(_vm._s(_vm.displaySchoolDate))])]), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "span": 3
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple"
	  })])], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.attendActive),
	      expression: "attendActive"
	    }]
	  }, [_c('el-button', {
	    staticStyle: {
	      "margin-left": "20px",
	      "float": "left"
	    },
	    attrs: {
	      "type": "info"
	    },
	    on: {
	      "click": _vm.getClasses
	    }
	  }, [_vm._v(" Back to Classes ")]), _vm._v(" "), (_vm.curClassDateActive) ? _c('el-button', {
	    attrs: {
	      "type": "info"
	    },
	    on: {
	      "click": _vm.subAttendance
	    }
	  }, [_vm._v(" Submit " + _vm._s(_vm.newAttend) + " Attendance Sheet ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.classAttend,
	      "border": "",
	      "fit": "",
	      "max-height": "800"
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": _vm.displayInfo
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "index",
	      "width": "60"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Students",
	      "width": "200"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', {
	          staticClass: "bolds",
	          staticStyle: {
	            "margin-left": "10px"
	          }
	        }, [_vm._v(_vm._s(scope.row.student_name) + " ")])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "(學/学)生中文名字",
	      "width": "200"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', {
	          staticClass: "link-type",
	          staticStyle: {
	            "margin-left": "10px"
	          },
	          on: {
	            "click": function($event) {
	              _vm.goEditStudentCName(scope.row)
	            }
	          }
	        }, [_vm._v(_vm._s(scope.row.chinese_name) + " ")]), _vm._v(" "), (scope.row.chinese_name == '') ? _c('span', {
	          staticClass: "link-small",
	          staticStyle: {
	            "margin-left": "10px"
	          },
	          on: {
	            "click": function($event) {
	              _vm.goEditStudentCName(scope.row)
	            }
	          }
	        }, [_vm._v("我的中文名字是? ")]) : _vm._e(), _vm._v(" "), (scope.row.notcname) ? _c('p') : _vm._e(), _vm._v(" "), (scope.row.notcname) ? _c('span', {
	          staticClass: "notcname",
	          staticStyle: {
	            "margin-left": "10px"
	          }
	        }, [_vm._v("像英文發音/寫中文名 ")]) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), (_vm.curClassDateActive) ? _c('el-table-column', {
	    attrs: {
	      "label": _vm.displayAttended,
	      "width": "100"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.absence == 0) ? _c('el-button', {
	          attrs: {
	            "size": "small",
	            "type": "success"
	          }
	        }, [_vm._v(" Present ")]) : _vm._e(), _vm._v(" "), (scope.row.absence != 0) ? _c('el-button', {
	          attrs: {
	            "size": "small"
	          },
	          on: {
	            "click": function($event) {
	              _vm.changeStatus(scope.$index, scope.row, 0)
	            }
	          }
	        }) : _vm._e()]
	      }
	    }])
	  }) : _vm._e(), _vm._v(" "), (_vm.curClassDateActive) ? _c('el-table-column', {
	    attrs: {
	      "label": _vm.displayAbsence,
	      "width": "100"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.absence != 1) ? _c('el-button', {
	          attrs: {
	            "size": "small"
	          },
	          on: {
	            "click": function($event) {
	              _vm.changeStatus(scope.$index, scope.row, 1)
	            }
	          }
	        }) : _vm._e(), _vm._v(" "), (scope.row.absence == 1) ? _c('el-button', {
	          attrs: {
	            "size": "small",
	            "type": "danger"
	          }
	        }, [_vm._v(" Absent ")]) : _vm._e()]
	      }
	    }])
	  }) : _vm._e(), _vm._v(" "), (_vm.curClassDateActive) ? _c('el-table-column', {
	    attrs: {
	      "label": _vm.displayLate,
	      "width": "80"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.absence == 2) ? _c('el-button', {
	          attrs: {
	            "size": "small",
	            "type": "danger"
	          }
	        }, [_vm._v(" Late ")]) : _vm._e(), _vm._v(" "), (scope.row.absence !== 2) ? _c('el-button', {
	          attrs: {
	            "size": "small"
	          },
	          on: {
	            "click": function($event) {
	              _vm.changeStatus(scope.$index, scope.row, 2)
	            }
	          }
	        }) : _vm._e()]
	      }
	    }])
	  }) : _vm._e(), _vm._v(" "), (_vm.curClassDateActive) ? _c('el-table-column', {
	    attrs: {
	      "label": _vm.displayLeft,
	      "width": "80"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.absence == 3) ? _c('el-button', {
	          attrs: {
	            "size": "small",
	            "type": "danger"
	          }
	        }, [_vm._v(" Left ")]) : _vm._e(), _vm._v(" "), (scope.row.absence !== 3) ? _c('el-button', {
	          attrs: {
	            "size": "small"
	          },
	          on: {
	            "click": function($event) {
	              _vm.changeStatus(scope.$index, scope.row, 3)
	            }
	          }
	        }) : _vm._e()]
	      }
	    }])
	  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.attendActive && !_vm.dialogHistory),
	      expression: "!attendActive &&  !dialogHistory"
	    }]
	  }, [_c('el-table', {
	    staticStyle: {
	      "margin-left": "20px"
	    },
	    attrs: {
	      "data": _vm.teacherClassesArr,
	      "max-height": "800",
	      "border": "",
	      "row-class-name": _vm.tableRowClassName
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": "Classes",
	      "prop": "fullclass",
	      "sortable": "",
	      "width": "150"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Title",
	      "prop": "title",
	      "width": "300"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "classroom",
	      "label": "Classroom ",
	      "width": "120"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "align": "center",
	      "label": "Take Attendance or 添加或修改中文名 ",
	      "width": "170"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-button', {
	          staticClass: "el-icon-circle-check",
	          attrs: {
	            "type": "info"
	          },
	          on: {
	            "click": function($event) {
	              _vm.getAttendance(scope.row)
	            }
	          }
	        })]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "align": "center",
	      "label": "Attendance History ",
	      "width": "120"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-button', {
	          staticClass: "el-icon-circle-check",
	          attrs: {
	            "type": "info"
	          },
	          on: {
	            "click": function($event) {
	              _vm.getHistory(scope.row)
	            }
	          }
	        })]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "align": "center",
	      "label": "Class List ",
	      "width": "120"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-button', {
	          staticClass: "el-icon-circle-check",
	          attrs: {
	            "type": "info"
	          },
	          on: {
	            "click": function($event) {
	              _vm.detailClass(scope.row)
	            }
	          }
	        })]
	      }
	    }])
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.dialogHistory),
	      expression: "dialogHistory"
	    }]
	  }, [_c('el-row', [_c('el-col', {
	    staticClass: "bolds",
	    attrs: {
	      "span": 20
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple-light",
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v(_vm._s(_vm.DialogInfo))])])], 1), _vm._v(" "), _c('el-button', {
	    staticStyle: {
	      "margin-bottom": "10px",
	      "margin-left": "30px",
	      "float": "left"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.doneHistory()
	      }
	    }
	  }, [_vm._v("Back")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', [_c('el-col', {
	    staticClass: "bolds",
	    attrs: {
	      "span": 20
	    }
	  }, [_c('div', {
	    staticClass: "grid-content bg-purple-light",
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('span', {
	    staticClass: "bolds"
	  }, [_vm._v(" Show Certain Months ::: Begin Month ")]), _vm._v(" "), _c('el-date-picker', {
	    attrs: {
	      "type": "month",
	      "placeholder": "Pick begin month"
	    },
	    on: {
	      "change": _vm.dateBegin
	    },
	    model: {
	      value: (_vm.monthB),
	      callback: function($$v) {
	        _vm.monthB = $$v
	      },
	      expression: "monthB"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "bolds"
	  }, [_vm._v("   End Month")]), _vm._v(" "), _c('el-date-picker', {
	    attrs: {
	      "type": "month",
	      "placeholder": "Pick End month"
	    },
	    on: {
	      "change": _vm.dateEnd
	    },
	    model: {
	      value: (_vm.monthE),
	      callback: function($$v) {
	        _vm.monthE = $$v
	      },
	      expression: "monthE"
	    }
	  })], 1)])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.attendHistory,
	      "max-height": "800",
	      "border": ""
	    },
	    on: {
	      "cell-click": _vm.getOneHist
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "fixed": "",
	      "type": "index",
	      "width": "60"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "fixed": "",
	      "label": "Students",
	      "width": "200"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', {
	          staticClass: "bolds",
	          staticStyle: {
	            "margin-left": "10px"
	          }
	        }, [_vm._v(_vm._s(scope.row.student_name) + " ")])]
	      }
	    }])
	  }), _vm._v(" "), _vm._l((_vm.disCols), function(col) {
	    return _c('el-table-column', {
	      key: col.prop,
	      attrs: {
	        "prop": col.prop,
	        "label": col.label,
	        "width": col.width,
	        "formatter": _vm.formatCell
	      }
	    })
	  })], 2)], 1), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.DialogInfo,
	      "show-close": false,
	      "visible": _vm.dialogOneHist,
	      "size": "full"
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.dialogOneHist = $event
	      }
	    }
	  }, [_c('el-button', {
	    staticStyle: {
	      "margin-bottom": "20px",
	      "float": "left"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.DoneOneHist()
	      }
	    }
	  }, [_vm._v("Back")]), _vm._v(" "), _c('el-button', {
	    staticStyle: {
	      "margin-left": "20px",
	      "float": "left"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.AttendanceEmail()
	      }
	    }
	  }, [_vm._v("Send Attendance Email")]), _vm._v(" "), _c('el-table', {
	    ref: "multipleTable",
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.classAttend,
	      "max-height": "800",
	      "border": ""
	    },
	    on: {
	      "selection-change": _vm.handleSelectionChange
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "label": _vm.displayInfo
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "index",
	      "width": "60"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Students",
	      "width": "200"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', {
	          staticClass: "bolds",
	          staticStyle: {
	            "margin-left": "10px"
	          }
	        }, [_vm._v(_vm._s(scope.row.student_name) + " ")])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.displayAttended,
	      "width": "100"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.absence == 0) ? _c('el-button', {
	          attrs: {
	            "size": "small",
	            "type": "success"
	          }
	        }, [_vm._v(" Present ")]) : _vm._e(), _vm._v(" "), (scope.row.absence != 0) ? _c('el-button', {
	          attrs: {
	            "size": "small"
	          }
	        }) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.displayAbsence,
	      "width": "100"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.absence != 1) ? _c('el-button', {
	          attrs: {
	            "size": "small"
	          }
	        }) : _vm._e(), _vm._v(" "), (scope.row.absence == 1) ? _c('el-button', {
	          attrs: {
	            "size": "small",
	            "type": "danger"
	          }
	        }, [_vm._v(" Absent ")]) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.displayLate,
	      "width": "80"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.absence == 2) ? _c('el-button', {
	          attrs: {
	            "size": "small",
	            "type": "danger"
	          }
	        }, [_vm._v(" Late ")]) : _vm._e(), _vm._v(" "), (scope.row.absence !== 2) ? _c('el-button', {
	          attrs: {
	            "size": "small"
	          }
	        }) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": _vm.displayLeft,
	      "width": "80"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.absence == 3) ? _c('el-button', {
	          attrs: {
	            "size": "small",
	            "type": "danger"
	          }
	        }, [_vm._v(" Left ")]) : _vm._e(), _vm._v(" "), (scope.row.absence !== 3) ? _c('el-button', {
	          attrs: {
	            "size": "small"
	          }
	        }) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Email Absent Students",
	      "width": "200"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.absence == 1) ? _c('span', {
	          attrs: {
	            "size": "small"
	          }
	        }, [_vm._v("  " + _vm._s(scope.row.email) + " ")]) : _vm._e()]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "type": "selection",
	      "width": "55"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": "Setup Email",
	      "size": "full",
	      "show-close": false,
	      "visible": _vm.dialogTeacherForm
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.dialogTeacherForm = $event
	      }
	    }
	  }, [_c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.teacher_InputArr
	    }
	  }, [_c('el-table-column', {
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-form', {
	          attrs: {
	            "label-position": "left"
	          }
	        }, [_c('el-form-item', {
	          attrs: {
	            "label": "Reply to (Email):",
	            "label-width": _vm.formLabelWidth
	          }
	        }, [_c('span', [_vm._v(_vm._s(scope.row.email))])]), _vm._v(" "), _c('el-form-item', {
	          attrs: {
	            "label": "Subject :",
	            "label-width": _vm.formLabelWidth
	          }
	        }, [_c('span', [_vm._v(_vm._s(scope.row.subject))])]), _vm._v(" "), _c('el-form-item', {
	          attrs: {
	            "label": "Message (Body)",
	            "label-width": _vm.formLabelWidth
	          }
	        }, [_c('span', [_vm._v(_vm._s(scope.row.message))])])], 1)]
	      }
	    }])
	  })], 1), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": _vm.EditTeacherCancel
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.EditTeacher()
	      }
	    }
	  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": "Edit Student Chinese Name (添加或修改中文名)",
	      "show-close": false,
	      "visible": _vm.dialogStudentForm
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.dialogStudentForm = $event
	      }
	    }
	  }, [_c('el-form', {
	    attrs: {
	      "model": _vm.getrow
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "中文名",
	      "label-width": _vm.formLabelWidth
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "auto-complete": "off"
	    },
	    model: {
	      value: (_vm.getrow.chinese_name),
	      callback: function($$v) {
	        _vm.getrow.chinese_name = $$v
	      },
	      expression: "getrow.chinese_name"
	    }
	  })], 1)], 1), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    slot: "footer"
	  }, [_c('el-button', {
	    on: {
	      "click": _vm.EditStudentCancel
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.EditStudent()
	      }
	    }
	  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": _vm.DialogInfo,
	      "show-close": false,
	      "visible": _vm.dialogClassCode,
	      "size": "full"
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.dialogClassCode = $event
	      }
	    }
	  }, [_c('el-button', {
	    staticStyle: {
	      "margin-bottom": "20px",
	      "float": "left"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        _vm.DoneDialogClassCode()
	      }
	    }
	  }, [_vm._v("Back")]), _vm._v(" "), _c('el-button', {
	    staticStyle: {
	      "margin-bottom": "20px",
	      "float": "right"
	    },
	    attrs: {
	      "type": "primary",
	      "icon": "document"
	    },
	    on: {
	      "click": function($event) {
	        _vm.handleDownload('')
	      }
	    }
	  }, [_vm._v("EC list Excel")]), _vm._v(" "), _c('el-button', {
	    staticStyle: {
	      "margin-bottom": "20px",
	      "float": "right"
	    },
	    attrs: {
	      "type": "primary",
	      "icon": "document"
	    },
	    on: {
	      "click": function($event) {
	        _vm.handleDownload('pdf')
	      }
	    }
	  }, [_vm._v("EC list PDF")]), _vm._v(" "), _c('el-button', {
	    staticStyle: {
	      "margin-bottom": "20px",
	      "float": "right"
	    },
	    attrs: {
	      "type": "primary",
	      "icon": "document"
	    },
	    on: {
	      "click": function($event) {
	        _vm.handleDownload('cp')
	      }
	    }
	  }, [_vm._v("For Simple Class Parent Excel")]), _vm._v(" "), _c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.classAttendArr,
	      "border": ""
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "index",
	      "width": "60"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Date",
	      "prop": "created",
	      "sortable": "",
	      "width": "180"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', [_vm._v(_vm._s(_vm._f("formatDate")(scope.row.created)) + " ")])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Students",
	      "prop": "last_name",
	      "sortable": "",
	      "width": "150"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', [_vm._v(" " + _vm._s(scope.row.student_name))])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "chinese_name",
	      "label": "中文名 ",
	      "width": "120"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Parents",
	      "prop": "father_lname",
	      "sortable": "",
	      "width": "150"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', {
	          staticStyle: {
	            "margin-left": "10px"
	          }
	        }, [_vm._v(_vm._s(scope.row.father_fname) + " " + _vm._s(scope.row.father_lname))])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Parents2",
	      "width": "150"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', [_vm._v(_vm._s(scope.row.parent2))])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Email",
	      "width": "250"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', {
	          staticStyle: {
	            "margin-left": "10px"
	          }
	        }, [_vm._v(_vm._s(scope.row.email) + " ")])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Phone",
	      "width": "140"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', [_vm._v(_vm._s(_vm._f("phone")(scope.row.phone)) + " ")])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "EC Person",
	      "width": "180"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', {
	          staticStyle: {
	            "margin-left": "10px"
	          }
	        }, [_vm._v(_vm._s(scope.row.ecp_name) + " ")])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Medical Condition",
	      "width": "180"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', {
	          staticStyle: {
	            "margin-left": "10px"
	          }
	        }, [_vm._v(_vm._s(scope.row.medical_cond) + " ")])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Allergy",
	      "width": "180"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', {
	          staticStyle: {
	            "margin-left": "10px"
	          }
	        }, [_vm._v(_vm._s(scope.row.allergy) + " ")])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Dr. Name",
	      "width": "180"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', {
	          staticStyle: {
	            "margin-left": "10px"
	          }
	        }, [_vm._v(_vm._s(scope.row.doctor_name) + " ")])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Dr. Phone",
	      "width": "180"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', {
	          staticStyle: {
	            "margin-left": "10px"
	          }
	        }, [_vm._v(_vm._s(scope.row.doctor_phone) + " ")])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Medical Insurance",
	      "width": "180"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', {
	          staticStyle: {
	            "margin-left": "10px"
	          }
	        }, [_vm._v(_vm._s(scope.row.ins_company) + " ")])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Insurance #",
	      "width": "180"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('span', {
	          staticStyle: {
	            "margin-left": "10px"
	          }
	        }, [_vm._v(_vm._s(scope.row.ins_policy) + " ")])]
	      }
	    }])
	  })], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 270:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login-container"
	  }, [_c('el-form', {
	    staticClass: "card-box login-form",
	    attrs: {
	      "autoComplete": "on",
	      "model": _vm.credentials,
	      "rules": _vm.rules,
	      "label-position": "left",
	      "label-width": "0px"
	    }
	  }, [_c('h3', {
	    staticClass: "title"
	  }, [_vm._v("Teacher Login")]), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "prop": "user_login"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "name": "email",
	      "type": "text",
	      "autoComplete": "on",
	      "placeholder": "Login Name"
	    },
	    model: {
	      value: (_vm.credentials.user_login),
	      callback: function($$v) {
	        _vm.credentials.user_login = $$v
	      },
	      expression: "credentials.user_login"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "prop": "user_password"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "name": "password",
	      "type": "password",
	      "autoComplete": "on",
	      "placeholder": "密码:Password"
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
	        _vm.submit($event)
	      }
	    },
	    model: {
	      value: (_vm.credentials.user_password),
	      callback: function($$v) {
	        _vm.credentials.user_password = $$v
	      },
	      expression: "credentials.user_password"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "type": "primary"
	    },
	    nativeOn: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submit($event)
	      }
	    }
	  }, [_vm._v("\n                    Login\n                ")])], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 271:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('HeaderCompontent'), _vm._v(" "), _c('keep-alive', [_c('router-view')], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-menu', {
	    attrs: {
	      "theme": "dark",
	      "lass": "el-menu-demo",
	      "mode": "horizontal"
	    }
	  }, [(_vm.teacher.authenticated) ? _c('el-menu-item', {
	    attrs: {
	      "index": "7"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/attendance"
	    }
	  }, [_vm._v("Attendance")])], 1) : _vm._e(), _vm._v(" "), (!_vm.teacher.authenticated) ? _c('el-menu-item', {
	    attrs: {
	      "index": "10"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/teacherlogin"
	    }
	  }, [_vm._v("Teacher Login")])], 1) : _vm._e(), _vm._v(" "), (_vm.teacher.authenticated) ? _c('el-menu-item', {
	    attrs: {
	      "index": "12"
	    },
	    on: {
	      "click": function($event) {
	        _vm.logout()
	      }
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_vm._v("Logout")])], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.883a54ffec52dad4198b.js